import React from 'react'
import RootStack from './stacks/RootStack'
import './App.css'
const App = () => {
  return (
    <RootStack />
  )
}

export default App
